import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form';
import { withRouter } from 'react-router-dom';
import { CustomDropdown } from '../../../../../common/custom-form/custom-dropdown.component';
import { SelectFieldFloatingLabel } from '../../../../../common/custom-form/select-filter.component';
import { InputFieldFloatingLabel as InputField } from '../../../../../common/custom-form/select-filter.component';
import { ACTION_TYPES, MAX_LENGTH, MODAL_CUSTOM_MESSAGE, MODAL_CUSTOM_TITLE } from '../../../../../../constants/external-constants';
import { Button } from "react-bootstrap";
import { ConfirmationNotificationModal } from '../../../../../common/modal/confirmation-modal.component';
import TableWithButton from '../../../../../common/details-table/table-with-button.component';
import { areDataEqual } from '../../../../../../utils/helpers.utils';
import Translation from "../../../../../../components/common/translation/translation.component";
import { NotificationModal } from '../../../../../common/modal/notification-modal.component';
import { CONFIRMATION_VALUE } from '../../../../../../utils/constant.utils';
import { RechargeInventoryDetailsActions } from '../../../../../../store/external/recharge-reducer/recharge-inventory-details.reducer/recharge-inventory-details.reducer';
import CustomSearchableSelectWrapper from '../../../../../common/custom-form/custom-searchable-select-wrapper.component';
import { ConfirmationModal } from "../../../../../common/modal/modal.component";
import { TRANSLATIONS as translation } from "../../../../../../utils/constant.utils";
import MappingInformationIcon from './mapping-information-icon';
import { articleCatalogueActions } from '../../../../../../store/external/recharge-reducer/article-catalogue-reducer/article-catalogue.reducer';
import { articleCatalogueMilestoneActions } from '../../../../../../store/external/recharge-reducer/article-catalogue-milestone.reducer/article-catalogue-milestone.reducer';
import { debitorCatalogueActions } from '../../../../../../store/external/recharge-reducer/debitor-catalogue-reducer/debitor-catalogue.reducer';
import store from '../../../../../../store';
import CustomSearchableDropdownWrapper from '../../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper';

class MappingInformation extends Component {
    constructor(props) {
        super(props);
        this.ConfirmationModal = React.createRef();
        this.state = {
            activeDropdown: false,
            showDetails: false,
            showModal: false,
            showNotif: false,
            showConfModal: false,
            showConfMessage: "",
            showConfTitle: "",
            notifTitle: null,
            tableLength: 0,
            isUpdate: false,
            isLoading: true,
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
        }
    }

    async componentDidMount(){
        const { getMappingInformationList, rechargeInventoryId, getArticleCatalogueDropdownList, getCostCodeList} = this.props
            getMappingInformationList(rechargeInventoryId).then(() =>{
                const { mappingInformationList } = this.props.rechargeInventoryDetails;
                const tableLength = mappingInformationList?.datatable[0]?.dataItem?.length;
                this.setState({ tableLength });
            });
        getArticleCatalogueDropdownList();
        this.getDebitorCatalogueDetails();
        getCostCodeList();
        this.setState({
            isLoading: false
        })
    }

    getDebitorCatalogueDetails() {
        const { getDebitorCatalogue, getDebitorCatalogueDropdownList, getDebitorCatalogueForm } = this.props
        const DebitorId = this.props.mappingInformationList?.datatable[0]?.dataItem[0];

        getDebitorCatalogue();
        getDebitorCatalogueDropdownList();
        getDebitorCatalogueForm(DebitorId);
    }


    handleToggle = () =>{
        const { getCostCodeList, getSelectedCostCode, mappingInformation } = this.props;
        getCostCodeList();
        this.setState(prev => ({activeDropdown: !prev.activeDropdown}));
    }

    isUpdateButtonEnabled = (state, form, circuitList) => {
      
        
    return false;
    }

    onClickCancel = () => {
        const { resetMappingInformationForm } = this.props;
        this.toggleActiveState();
        resetMappingInformationForm();

        this.setState({
            updateSimDetails: false,
            debitorHasError: false,
            articleHasError: false
        });
    }

    onClickAdd = () =>{
        this.setState({
            showModal: true,
            notifTitle: 'added'
        })
    };

    handleConfirmationModal = (buttonType) =>{
            if (buttonType === CONFIRMATION_VALUE.Ok){
                this.state.isUpdate ? this.updateMappingInformation() : this.addMappingInformation()
                this.props.handleChangesStatus('modalInformationChange', true);
                this.setState( prev => ({
                    showModal: !prev.showModal,
                    showNotif: false
                }))
            }else{
                this.setState({
                    showModal: false
                });
            }
    };

    setMappingStatusOnUpdate = () => {
        
    }


    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    toggleActiveState = () => {
            
        this.setState(prevState => ({ activeDropdown: !prevState.activeDropdown }));

    }

    addMappingInformation = () => {
        const { addMappingInformationItem, resetMappingInformationForm } = this.props;
    
        addMappingInformationItem();
        resetMappingInformationForm();
        this.toggleActiveState(false);
    }

    updateMappingInformation = () => {
        const { updateMappingInformationItem, resetMappingInformationForm, rechargeInventoryDetails, rechargeInventoryDetailsForm } = this.props;

        updateMappingInformationItem();
        resetMappingInformationForm();
    
        this.setState({
            updateSimDetails: false,
            notifTitle: 'updated',
            activeDropdown: false
        });
    }

    deleteMappingInformation = (index) =>{
        const { deleteMappingInformationItem, handleChangesStatus, resetMappingInformationForm } = this.props;
    
        const {mappingInformationList} = this.props.rechargeInventoryDetails;
    
        deleteMappingInformationItem(index);    
    
        const updatedMappingInformationList = mappingInformationList;
    
        let newTable = updatedMappingInformationList?.datatable[0]?.dataItem;
    
        newTable.splice(index, 1); 
    
        handleChangesStatus('modalInformationChange', true);
    
        resetMappingInformationForm();
    
        this.setState({
            activeDropdown: false,
            updateSimDetails: false,
            isUpdate: false
        })
    }

    onRowClick = async (index) => {
        const { viewMappingInformation, getCostCodeList, getSelectedCostCode, mappingInformation } = this.props;
        await viewMappingInformation(index).then((res) =>{

            let costCodeValue = "";

            if(res?.CostCenterID){
                getSelectedCostCode(res?.CostCenterID).then(response =>{

                     getCostCodeList(1, response).then(() =>{
                        this.setState({
                        activeDropdown: true,
                        isUpdate: true
                        });
                    });

                });
            }          
            
        });
        this.isActiveDropDownState();

        
    }

    isActiveDropDownState = () => {
        this.setState(prevState => ({ activeDropdown: !prevState.activeDropdown }));
    }

    handleOpenNotif = () => {
        this.setState({
            showNotif: true,
            notifTitle: 'deleted'
        });
    }

    handleConfModal = (buttonType) => {
        if (buttonType === CONFIRMATION_VALUE.Ok) {
            this.setState({
                showConfModal: false,
                showConfMessage: "",
                showConfTitle: "",
            });
        } else {
            this.setState({
                showConfModal: false,
                showConfMessage: "",
                showConfTitle: "",
            });
        }
    };

    toggleSaveNotif = (isShow, title, message) => {
        const { saveNotif } = this.state;

        this.setState({
            saveNotif: {
                ...saveNotif,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
            }
        });

        if (!isShow && saveNotif.message.toLowerCase() === ("Recharging Mapping has been mapped.").toLowerCase()) {
            this.setState({
                saveNotif: {
                    ...saveNotif,
                    show: false,
                    title: title ?? "",
                    message: message ?? "",
                }
            });
        }

    }

    toggleSaveModal = (isShow, title, message, confirmAction = () => { }) => {
        const { saveModal } = this.state;

        if (isShow) {
            this.ConfirmationModal.current.handleShow();
        }
        else {
            this.ConfirmationModal.current.handleClose();
        }

        this.setState({
            saveModal: {
                ...saveModal,
                title: title ?? "",
                messageBody: message ?? "",
                confirmAction: confirmAction
            },
        });
    };

    refreshMappingInformation = async (index, validate = 1) => {
        const { refreshRechargeInventory, getRechargeInventory, getMappingInformationList, rechargeInventoryId } = this.props;

        this.setState({
            isSaving: true
        });

        var result = await refreshRechargeInventory(rechargeInventoryId, validate);

        this.setState({
            isSaving: false
        });

        if (result.success === false) {
            if (result.isValid) {
                const confirmMessage = MODAL_CUSTOM_MESSAGE.mapping_confirmation;
                const modalTitle = MODAL_CUSTOM_TITLE.MapInventory;
                var confirmAction = () => this.refreshMappingInformation(rechargeInventoryId, 0)
                this.toggleSaveModal(true, modalTitle, confirmMessage, confirmAction);
                return;
            }
            else {
                this.toggleSaveModal(false);
                this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), result.message);
                return;
            }
        }
        else {
            // Refresh form with updated values
            await getRechargeInventory(rechargeInventoryId);
            getMappingInformationList(rechargeInventoryId).then(() => {
                const originalMappingInformationDataCopy = JSON.parse(JSON.stringify(this.props.rechargeInventoryDetails.mappingInformationList));
                this.props.loadUpdatedMappingInfo(originalMappingInformationDataCopy);


                const updatesMappingStatusId = originalMappingInformationDataCopy?.datatable[0]?.dataItem[0]?.MappingStatusID
                store.dispatch(actions.change("rechargeInventoryDetailsForm.mappingInformation.MappingStatusID", updatesMappingStatusId))

                store.dispatch(
                    actions.load(
                        "rechargeInventoryDetailsForm.mappingInformation",
                        originalMappingInformationDataCopy?.datatable?.[0]?.dataItem?.[0] || {}
                    )
                );
            });

            const modalTitle = this.toLocaleLanguage("success_modal_title");
            this.toggleSaveModal(false);
            this.toggleSaveNotif(true, modalTitle, result.message);
            return;
        }
    }

    onRefreshMapping = async () => {
        await this.refreshMappingInformation();
    }

    enableUpdateBtn = () => {
        const { rechargeInventoryDetails, rechargeInventoryDetailsForm } = this.props
        const { mappingInformationList } = rechargeInventoryDetails
        const { mappingInformation } = rechargeInventoryDetailsForm

        const enableUpdateBtn = this.state.isUpdate &&
            mappingInformation.ArticleNumber &&
            mappingInformation.DebitorNumber &&
            mappingInformation.SalesOrganizationNumber &&
            mappingInformation.VatGroupID &&
            mappingInformation.PriceCalculationID &&
            (areDataEqual(mappingInformation, mappingInformationList?.datatable[0]?.dataItem[0]));

        return enableUpdateBtn;
    }

    loadMoreCostCode= (searchString) => {
        const { getCostCodeList, rechargeInventoryDetails } = this.props;

            getCostCodeList(rechargeInventoryDetails.costCodePage + 1, searchString);
    }

    handleSearchCostCode = (query) => {        
        const {getCostCodeList} = this.props;

        if(query === null) return;

        getCostCodeList(1, query);
    }

    render() {
        const { translator } = this.props;

        const { rechargeInventoryDetails, rechargeInventoryDetailsForm, isReadAndWrite } = this.props
        const { mappingInformationList } = rechargeInventoryDetails
        const { mappingInformation } = rechargeInventoryDetailsForm

        const enableAddBtn = (mappingInformation.ArticleNumber && mappingInformation.DebitorNumber && mappingInformation.SalesOrganizationNumber
                            && mappingInformation.VatGroupID && mappingInformation.PriceCalculationID) ? true : false;

        const noMappingInformation = mappingInformationList?.datatable?.[0]?.dataItem?.length === 0;

        const ArticleId = mappingInformationList?.datatable[0]?.dataItem[0]?.ArticleId;
        const DebitorId = mappingInformationList?.datatable[0]?.dataItem[0]?.DebitorId;

        const errorDebitorNumber = !DebitorId && (mappingInformation.MappingStatusID === 3 || mappingInformation.MappingStatusID === 4)
        const errorArticleNumber = !ArticleId && DebitorId && (mappingInformation.MappingStatusID === 3 || mappingInformation.MappingStatusID === 4)

        return (
            <>
                <ConfirmationModal
                    ref={this.ConfirmationModal}
                    title={this.state.saveModal.title}
                    messageBody={this.state.saveModal.messageBody}
                    confirmAction={this.state.saveModal.confirmAction}
                    closeLabel={this.toLocaleLanguage("cancel_button")}
                    confirmLabel={this.toLocaleLanguage("yes_button")}
                    disabled={this.state.isSaving}
                />
                <NotificationModal
                    show={this.state.saveNotif.show}
                    title={this.state.saveNotif.title}
                    message={this.state.saveNotif.message}
                    handleModal={() => this.toggleSaveNotif(false)}
                    customClass={'comment-notification-modal modal-text-bold notification-footer'}
                />  
                <CustomDropdown activeDropdown={this.state.activeDropdown} toggleActiveState={() => { if (noMappingInformation) {this.handleToggle();}}} label={translator("mapping_information", false)} >
                    <div className={`add-equipment-container detail-page-container details-4-col-container capital-uppercase ${ArticleId ? 'icon-padding-left' : ''}`}>
                        <div className="detail-with-icon-container">
                            {ArticleId && (
                                <MappingInformationIcon
                                    mappingInformationList={mappingInformationList}
                                    iconName={"article-icon"} />
                            )}
                            <InputField
                                className="form-control required"
                                type="text"
                                label={translator('article_number')}
                                value={rechargeInventoryDetailsForm.mappingInformation.ArticleNumber}
                                fieldProp='rechargeInventoryDetailsForm.mappingInformation.ArticleNumber'
                                placeholder={`${translator('enter_text_placeholder', false)}`}
                                maxLength={MAX_LENGTH.limit_20}
                                isError={errorArticleNumber}
                            />
                    </div>
                    <InputField
                        className="form-control"
                        type="text"
                        label={translator('article_name')}
                        value={mappingInformation.ArticleName}
                        fieldProp='rechargeInventoryDetailsForm.mappingInformation.ArticleName'
                        placeholder={`${translator('enter_text_placeholder', false)}`}
                        maxLength={MAX_LENGTH.limit_100}
                        />

                        <div className="detail-with-icon-container">
                            {DebitorId && (
                                <MappingInformationIcon
                                    mappingInformationList={mappingInformationList}
                                    iconName={"debitor-icon"} />
                            )}
                            <InputField
                                className="form-control required"
                                type="text"
                                label={translator('debitor_number')}
                                value={mappingInformation.DebitorNumber}
                                fieldProp='rechargeInventoryDetailsForm.mappingInformation.DebitorNumber'
                                placeholder={`${translator('enter_text_placeholder', false)}`}
                                maxLength={MAX_LENGTH.inputText}
                                isError={errorDebitorNumber}
                            />
                        </div>
                    
                    <InputField
                        className="form-control"
                        type="text"
                        label={translator('debitor_name')}
                        value={mappingInformation.DebitorName}
                        fieldProp='rechargeInventoryDetailsForm.mappingInformation.DebitorName'
                        placeholder={`${translator('enter_text_placeholder', false)}`}
                        maxLength={MAX_LENGTH.limit_255}
                    />
                     <CustomSearchableDropdownWrapper
                        label={translator('cost_center')}
                        options={rechargeInventoryDetails.rechargeCostCode}
                        selected={rechargeInventoryDetails.rechargeCostCode?.length > 0? mappingInformation.CostCenterID : null}
                        onChange={() => { }}
                        placeholder={translator('select_placeholder', false)}
                        fieldProp='rechargeInventoryDetailsForm.mappingInformation.CostCenterID'
                        isNullable={true}
                        tagName='tagName'
                        optionLabelKey={{
                            Key: 'Key',
                            Value: 'Value'
                        }}
                        maxLength={MAX_LENGTH.inputText}
                        disabled={false}
                        onSearchChange={this.handleSearchCostCode}
                        onLoadMore={(val) => this.loadMoreCostCode(val)}
                        isLoading={!this.props?.rechargeInventoryDetails?.isCostCodeListLoaded}
                        hasMore={rechargeInventoryDetails?.hasMoreCostCode}
                     />
                    <InputField
                        className="form-control required"
                        type="text"
                        label={translator('sales_organization_number')}
                        value={mappingInformation.SalesOrganizationNumber}
                        fieldProp='rechargeInventoryDetailsForm.mappingInformation.SalesOrganizationNumber'
                        placeholder={`${translator('enter_text_placeholder', false)}`}
                        maxLength={MAX_LENGTH.limit_10}
                    />
                    <SelectFieldFloatingLabel
                        className="form-select no-select__option required"
                        label={translator('vat_group')}
                        options={rechargeInventoryDetails.rechargeInventoryDetailsDropDownList.VatGroup}
                        value={mappingInformation.VatGroupID}
                        placeholder={translator('select_placeholder', false)}
                        fieldProp='rechargeInventoryDetailsForm.mappingInformation.VatGroupID'
                        optionLabelKey={{
                            Key: "Key",
                            Value: "Value"
                        }}
                    />

                    <SelectFieldFloatingLabel
                        className="form-select no-select__option required"
                        label={translator('price_calculation')}
                        options={rechargeInventoryDetails.rechargeInventoryDetailsDropDownList.PriceCalculation}
                        value={mappingInformation.PriceCalculationID}
                        placeholder={translator('select_placeholder', false)}
                        fieldProp='rechargeInventoryDetailsForm.mappingInformation.PriceCalculationID'
                        optionLabelKey={{
                            Key: "Key",
                            Value: "Value"
                        }}
                    />

                    <InputField
                        className="form-control"
                        type="text"
                        label={translator('additional_attribute')}
                        value={mappingInformation.AdditionalAttribute}
                        fieldProp='rechargeInventoryDetailsForm.mappingInformation.AdditionalAttribute'
                        placeholder={`${translator('enter_text_placeholder', false)}`}
                        maxLength={MAX_LENGTH.limit_255}
                    />

                    <SelectFieldFloatingLabel
                        className="form-select no-select__option"
                        label={translator('mapping_status')}
                        options={rechargeInventoryDetails.rechargeInventoryDetailsDropDownList.MappingStatus}
                        value={rechargeInventoryDetailsForm.mappingInformation.MappingStatusID}
                        fieldProp='rechargeInventoryDetailsForm.mappingInformation.MappingStatusID'
                        optionLabelKey={{
                            Key: "Key",
                            Value: "Value"
                        }}
                        disabled={true}
                    />
                    {
                        isReadAndWrite &&

                            <div className="add-button-container custom-add-button">
                                {!false &&
                                    <div className="btn-tooltiptext">
                                        <Button onClick={this.onClickCancel} className="btn-custom-violet-hover-outline">Cancel</Button>
                                        <span className="tooltip-text">{!noMappingInformation ? <Translation translationKey="cancel_update_mapping_info" /> : <Translation translationKey="cancel_add_mapping_info" />}</span>
                                    </div>
                                }
                                <ConfirmationNotificationModal
                                    show={this.state.showModal}
                                    message={this.state.isUpdate ? 'Are you sure you want to update?' : 'Are you sure you want to add?'}
                                    title={this.state.isUpdate ? 'Update' : 'Add'}
                                    handleModal={this.handleConfirmationModal}
                                    customClass={'comment-notification-modal modal-text-bold'}
                                />
                                {!false &&
                                    <div className={'btn-tooltiptext'}>
                                        <Button
                                            className="btn-add"
                                            disabled={this.state.isUpdate ? this.enableUpdateBtn() : !enableAddBtn }
                                            onClick={this.onClickAdd}>{`${!noMappingInformation ? ACTION_TYPES.Update : ACTION_TYPES.Add}`}
                                        </Button>
                                        <span className="tooltip-text">{!noMappingInformation ? <Translation translationKey="update_mapping_info" /> : <Translation translationKey="add_mapping_info" />}</span>
                                    </div>
                                }
                            </div>

                    }                        
                </div>
            </CustomDropdown>
            {
                    mappingInformationList.datatable[0]?.dataItem.length > 0 &&
                    <div className="table-no-scroll details-table-container add-equipment-container">
                        <TableWithButton
                            classNameWrapper="table-details-wrapper table-clickable table-max-width me-0"
                            datatable={mappingInformationList.datatable}
                            haveExternalDeleteBtn={isReadAndWrite ? true : false}
                            showRefreshBtn={isReadAndWrite ? true : false}
                            deleteAction={(index) => this.deleteMappingInformation(index)}
                            rowClickAction={this.onRowClick}
                            handleOpenNotif={this.handleOpenNotif}
                            handleRefresh={this.onRefreshMapping}
                            refreshTooltip={<Translation translationKey="map_recharging_details"/>}
                            deleteTooltip={<Translation translationKey="remove_mapping_info"/>}
                        />
                    </div>
                }
        </>
        );
    }
}


export default withRouter(connect(
    state => {
        const { rechargeInventoryDetails, translation } = state;
        const { rechargeInventoryDetailsForm,
            articleCatalogue,
            articleCatalogueMilestone,
            debitorCatalogue,
            forms: { rechargeInventoryDetailsForm: { $form } } } = state.form;
        return {
            ...translation,
            articleCatalogue,
            articleCatalogueMilestone,
            rechargeInventoryDetails,
            rechargeInventoryDetailsForm,
            debitorCatalogue,
            $form
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, RechargeInventoryDetailsActions,
                articleCatalogueActions,
                articleCatalogueMilestoneActions,
                debitorCatalogueActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        },
        FormLoad: (model, data) => {
            dispatch(actions.load(model, data));
        }
    })
)(MappingInformation));